import { useEffect, useState } from 'react';

/**
 * Dar ekran (telefon; Tailwind `md` kırılımının altı). Masaüstü penceresi en
 * az 1040 px olduğu için orada hep false — yalnızca web uygulamasında devreye
 * giriyor: kenar çubuğu çekmeceye dönüşüyor, üst çubuk sıkılaşıyor.
 */
const QUERY = '(max-width: 767px)';

export function isNarrowScreen(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches;
}

export function useIsNarrow(): boolean {
  const [narrow, setNarrow] = useState(isNarrowScreen);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(QUERY);
    const onChange = () => setNarrow(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);
  return narrow;
}
